import React from "react";
import { useUser } from "../../../../context/AuthContext";
import Scope3ApprovalListCore from "../Scope3ApprovalListCore";
import SimpleScope3ApprovalDrawer from "../SimpleScope3ApprovalDrawer";

/** Production month for table: always `YYYY-MM` (e.g. 2022-02). */
const formatEolMonthYYYYMM = (value) => {
  if (value === undefined || value === null || value === "") return "";
  const s = String(value).trim();
  const head = s.match(/^(\d{4})-(\d{2})/);
  if (head) return `${head[1]}-${head[2]}`;
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return s;
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}`;
};

/** List API returns populated `product`; legacy rows may use string productMaster or flat fields. */
const mapEolApprovalRow = (item) => {
  const pm =
    item?.productMaster && typeof item.productMaster === "object"
      ? item.productMaster
      : null;

  return {
    ...item,
    eolMonth: formatEolMonthYYYYMM(item?.eolMonth) || item?.eolMonth,
    productName:
      item?.product?.productName ??
      pm?.productName ??
      item?.productName ??
      "",
  };
};

const EolView = (props) => (
  <SimpleScope3ApprovalDrawer
    {...props}
    title="End of life treatment of sold products — change request"
  />
);

const EOLTreatmentOfSoldProductsApproval = () => {
  const { user } = useUser();

  const headings = [
    { title: "Date", key: "createdAt" },
    user?.companyAdmin ? { title: "Facility", key: "facilityName" } : null,
    { title: "Production Month", key: "eolMonth" },
    { title: "Product Name", key: "productName" },
    // { title: "EOL Treatment", key: "endOfLifeTreatmentMethod" },
    { title: "Status", key: "requestStatus", },
    { title: "Created By", key: "createdBy" },
  ].filter(Boolean);

  return (
    <Scope3ApprovalListCore
      pageTitle="End of Life Treatment of Sold Products"
      apiSegment="eolTreatmentOfSoldProducts"
      ViewPage={EolView}
      headings={headings}
      columnWidth={
        user?.companyAdmin
          ? "14% 16% 22% 16% 24% 8%"
          : "12% 20% 20% 18% 18% 8%"
      }
      mapRow={mapEolApprovalRow}
    />
  );
};

export default EOLTreatmentOfSoldProductsApproval;
